import React from 'react';
import PresentationManager from './PresentationManager';
import './styles/main.css';

function App() {
  return (
    <div className="app">
      <PresentationManager />
    </div>
  );
}

export default App;